// Constants
export const COUNTRY_GROUPS = {
  // Working Areas
  'GROUP-SEM': {
    id: 'GROUP-SEM',
    name: 'S.E.M.',
    countries: ['ES', 'MA', 'PT', 'IT', 'AD'],
  },
  'GROUP-FRANCE': {
    id: 'GROUP-FRANCE',
    name: 'Area France',
    countries: ['FR', 'GB', 'BE', 'IE', 'NL', 'LU'],
  },
  'GROUP-POLAND': {
    id: 'GROUP-POLAND',
    name: 'Area Poland',
    countries: ['PL', 'DE', 'CH', 'LT', 'EE', 'CZ', 'SK'],
  },
  'GROUP-ROMANIA': {
    id: 'GROUP-ROMANIA',
    name: 'Area Romania',
    countries: ['RO', 'BG', 'TR', 'HU', 'AT', 'SI'],
  },
  'GROUP-INTERNATIONAL': {
    id: 'GROUP-INTERNATIONAL',
    name: 'Area International',
    countries: ['DK', 'DZ', 'FI', 'GR', 'HR', 'LI', 'ME', 'MT', 'NO', 'RS', 'SE', 'TN'],
  },
  // 'GROUP-NOT-SUPPORTED': {
  //   id: 'GROUP-NOT-SUPPORTED',
  //   name: 'AreaCountries Not Supported in Ticket Form',
  //   countries: ['UA', 'MK'], // Ukraine, Macedonia
  // },
  // Individual country groups
  //   'GROUP-COUNTRY-UA': { id: 'GROUP-COUNTRY-UA', name: 'Ukraine', countries: ['UA'] },
  //   'GROUP-COUNTRY-MK': { id: 'GROUP-COUNTRY-MK', name: 'Macedonia', countries: ['MK'] },
  'GROUP-COUNTRY-AD': { id: 'GROUP-COUNTRY-AD', name: 'Andorra', countries: ['AD'] },
  'GROUP-COUNTRY-AT': { id: 'GROUP-COUNTRY-AT', name: 'Austria', countries: ['AT'] },
  'GROUP-COUNTRY-BE': { id: 'GROUP-COUNTRY-BE', name: 'Belgium', countries: ['BE'] },
  'GROUP-COUNTRY-BG': { id: 'GROUP-COUNTRY-BG', name: 'Bulgaria', countries: ['BG'] },
  'GROUP-COUNTRY-CH': { id: 'GROUP-COUNTRY-CH', name: 'Switzerland', countries: ['CH'] },
  'GROUP-COUNTRY-CZ': { id: 'GROUP-COUNTRY-CZ', name: 'Czechia', countries: ['CZ'] },
  'GROUP-COUNTRY-DE': { id: 'GROUP-COUNTRY-DE', name: 'Germany', countries: ['DE'] },
  'GROUP-COUNTRY-DK': { id: 'GROUP-COUNTRY-DK', name: 'Denmark', countries: ['DK'] },
  'GROUP-COUNTRY-DZ': { id: 'GROUP-COUNTRY-DZ', name: 'Algeria', countries: ['DZ'] },
  'GROUP-COUNTRY-EE': { id: 'GROUP-COUNTRY-EE', name: 'Estonia', countries: ['EE'] },
  'GROUP-COUNTRY-ES': { id: 'GROUP-COUNTRY-ES', name: 'Spain', countries: ['ES'] },
  'GROUP-COUNTRY-FI': { id: 'GROUP-COUNTRY-FI', name: 'Finland', countries: ['FI'] },
  'GROUP-COUNTRY-FR': { id: 'GROUP-COUNTRY-FR', name: 'France', countries: ['FR'] },
  'GROUP-COUNTRY-GB': { id: 'GROUP-COUNTRY-GB', name: 'UK', countries: ['GB'] },
  'GROUP-COUNTRY-GR': { id: 'GROUP-COUNTRY-GR', name: 'Greece', countries: ['GR'] },
  'GROUP-COUNTRY-HR': { id: 'GROUP-COUNTRY-HR', name: 'Croatia', countries: ['HR'] },
  'GROUP-COUNTRY-HU': { id: 'GROUP-COUNTRY-HU', name: 'Hungary', countries: ['HU'] },
  'GROUP-COUNTRY-IE': { id: 'GROUP-COUNTRY-IE', name: 'Ireland', countries: ['IE'] },
  'GROUP-COUNTRY-IT': { id: 'GROUP-COUNTRY-IT', name: 'Italy', countries: ['IT'] },
  'GROUP-COUNTRY-LI': { id: 'GROUP-COUNTRY-LI', name: 'Liechtenstein', countries: ['LI'] },
  'GROUP-COUNTRY-LT': { id: 'GROUP-COUNTRY-LT', name: 'Lithuania', countries: ['LT'] },
  'GROUP-COUNTRY-LU': { id: 'GROUP-COUNTRY-LU', name: 'Luxembourg', countries: ['LU'] },
  'GROUP-COUNTRY-MA': { id: 'GROUP-COUNTRY-MA', name: 'Morocco', countries: ['MA'] },
  'GROUP-COUNTRY-ME': { id: 'GROUP-COUNTRY-ME', name: 'Montenegro', countries: ['ME'] },
  'GROUP-COUNTRY-MT': { id: 'GROUP-COUNTRY-MT', name: 'Malta', countries: ['MT'] },
  'GROUP-COUNTRY-NL': { id: 'GROUP-COUNTRY-NL', name: 'Netherlands', countries: ['NL'] },
  'GROUP-COUNTRY-NO': { id: 'GROUP-COUNTRY-NO', name: 'Norway', countries: ['NO'] },
  'GROUP-COUNTRY-PL': { id: 'GROUP-COUNTRY-PL', name: 'Poland', countries: ['PL'] },
  'GROUP-COUNTRY-PT': { id: 'GROUP-COUNTRY-PT', name: 'Portugal', countries: ['PT'] },
  'GROUP-COUNTRY-RO': { id: 'GROUP-COUNTRY-RO', name: 'Romania', countries: ['RO'] },
  'GROUP-COUNTRY-RS': { id: 'GROUP-COUNTRY-RS', name: 'Serbia', countries: ['RS'] },
  'GROUP-COUNTRY-SE': { id: 'GROUP-COUNTRY-SE', name: 'Sweden', countries: ['SE'] },
  'GROUP-COUNTRY-SI': { id: 'GROUP-COUNTRY-SI', name: 'Slovenia', countries: ['SI'] },
  'GROUP-COUNTRY-SK': { id: 'GROUP-COUNTRY-SK', name: 'Slovakia', countries: ['SK'] },
  'GROUP-COUNTRY-TN': { id: 'GROUP-COUNTRY-TN', name: 'Tunisia', countries: ['TN'] },
  'GROUP-COUNTRY-TR': { id: 'GROUP-COUNTRY-TR', name: 'Turkey', countries: ['TR'] },
};

// Mapper functions
export const mapGroupsToCountryCodes = (groupId) => {
  return COUNTRY_GROUPS[groupId]?.countries ?? [].flat();
};

// Options for selects with search functionality
export const getCountryGroupOptions = () => {
  return Object.values(COUNTRY_GROUPS).map((group) => ({
    value: group.id,
    label: group.name,
    search: group.name,
    display: group.name,
  }));
};
